import React from 'react';

const Footer = () => {
    return (
        <footer className="footer footer-center p-4 bg-base-300 text-base-content">
            <div>
                <p>Copyright © 2022 - All right reserved by Shakeeb</p>
            </div>
        </footer>
    );
};

export default Footer;